// English texts of the "sync" area. Keys start with "sync."
export default {
  // engine/core/estimate.js: node estimate (a rough duration): unit buttons and value
  "sync.estimate.days": "Days",
  "sync.estimate.weeks": "Weeks",
  "sync.estimate.months": "Months",
  "sync.estimate.value.days_one": "{count} day",
  "sync.estimate.value.days_other": "{count} days",
  "sync.estimate.value.weeks_one": "{count} week",
  "sync.estimate.value.weeks_other": "{count} weeks",
  "sync.estimate.value.months_one": "{count} month",
  "sync.estimate.value.months_other": "{count} months",

  // engine/core/routine-duration.js: planned duration of a routine step
  "sync.duration.minutes": "{value} min",
  "sync.duration.hours_one": "{count} hour",
  "sync.duration.hours_other": "{count} hours",
  "sync.duration.days_one": "{count} day",
  "sync.duration.days_other": "{count} days",

  // engine/core/gantt-calendar.js: Gantt header labels, quarter and ISO week number (keep them short)
  "sync.gantt.quarter": "Q{n}",
  "sync.gantt.week": "W{n}",

  // engine/core/vault-folders.js: moving maps and folders in the vault
  "sync.folder.unavailable": "This folder is no longer available. Choose another destination.",
  "sync.folder.sameVault": "Choose a folder in the same vault. Use the online or local copy action to change storage.",
  "sync.folder.intoItself": "A folder cannot be moved into itself or one of its subfolders.",

  // engine/crypto/key-authority.js
  "sync.keyAuthority.unverified": "Map key authorization could not be verified. Sync is paused; local data and keys are retained.",

  // Name of a new node when none is given (stored in the map)
  "sync.node.defaultName": "New Node",

  // engine/sync/storage-health.js: a write attempted while saving is impossible
  "sync.storage.writesBlocked": "Storage or sync is unavailable. Writes are blocked to prevent data loss.",

  // engine/sync/node-operations.js, crdt-bridge.js: notices when an edit is refused
  "sync.edit.readOnly": "This map is read-only. Check its access and storage quota.",
  "sync.edit.mapFull": "This map is full: delete items, or cut branches and paste them into another map.",
  "sync.edit.linkedUnavailable": "Editing this linked map is unavailable. Check its access and storage quota.",
  "sync.edit.linkedNotShown": "This linked map isn't shown here. Open it to edit its content.",
  "sync.edit.linkedLoading": "Linked document hasn't finished loading — try again in a moment, or check that you still have access.",
  "sync.edit.noRoute": "Could not route the edit to its document.",
  "sync.edit.destinationLoading": "The destination has not finished loading. Please try again.",
  "sync.edit.crossDocMove": "Cannot move nodes across documents. Copy-paste instead.",
  "sync.edit.notesReadOnly": "The notes of this map are read-only here.",

  // engine/sync/crdt-bridge.js, store-rebuild.js: damaged map data
  "sync.orphans.recovered_one": "{count} orphaned node was detected and recovered. This may indicate browser data corruption. Please verify your data.",
  "sync.orphans.recovered_other": "{count} orphaned nodes were detected and recovered. This may indicate browser data corruption. Please verify your data.",
  "sync.corrupted.toast": "CRDT document appears corrupted",
  "sync.corrupted.unknownName": "Unknown",
  "sync.corrupted.reason": "CRDT data cannot be converted to a valid tree structure",

  // Setting aside server updates nobody can read; {status} is the HTTP status
  "sync.setAside.failed": "Could not set the updates aside ({status})",

  // engine/sync/crdt-bridge.js: routines, shown by the routines screen
  "sync.routine.importReadOnly": "Cannot import routines into a read-only or unopened map.",
  "sync.routine.readOnly": "This map is read-only.",
  "sync.routine.mapOpening": "Wait for the map to finish opening.",
  "sync.routine.unavailable": "This routine is no longer available.",
  "sync.routine.otherOccurrence": "This occurrence belongs to another routine.",
  "sync.routine.noteUnavailable": "This note is no longer available.",
  "sync.routine.resolveFirst": "Resolve or resume this routine before changing its completion.",
  "sync.routine.selectNote": "Select a note and an occurrence first.",
  "sync.routine.chooseCompletionDate": "Choose a completion date to resolve this occurrence.",
  "sync.routine.completionChanged": "The completion date changed. Review it again.",
  "sync.routine.chooseNextDate": "Choose the next date.",
  "sync.routine.sessionUnavailable": "This session is no longer available.",
  "sync.routine.sessionFinished": "This session was finished. Resume / correct it before saving your pending edits.",
  "sync.routine.timerChanged": "This timer changed in another tab or device. Review the saved minutes before adding your unsaved time.",
  "sync.routine.durationRange": "Choose a duration between 0 and 3660 days.",
  "sync.routine.validCompletionDate": "Choose a valid completion date.",

  // engine/sync/crdt-bridge.js: postponing a task
  "sync.postpone.notAllowed": "This task cannot be postponed.",
  "sync.postpone.afterToday": "Choose a date after today.",
  "sync.postpone.cannotChange": "This task cannot be changed.",
  "sync.postpone.noNote": "Create a note to receive this task first.",

  // Map names shown when a map has none (notes tabs, links to other maps)
  "sync.notes.mainDocument": "Main document",
  "sync.linked.defaultTitle": "Linked document",
  "sync.linked.noAccess": "{title} (no access)",
  "sync.linked.gone": "{title} (no longer online)",

  // Root branch that receives tasks typed into a note's task list. Stored as the node's name.
  // crdt-bridge.js finds the branch by this name in every language: when changing a
  // translation, add the new name to UNSORTED_BRANCH_NAMES there.
  "sync.unsorted.name": "Unsorted",

  // engine/sync/crdt-bridge.js: access to a linked map was revoked. The *Unnamed texts are used
  // when the map's title is unknown.
  "sync.linkedRevoked.thisDocument": "this linked document",
  "sync.linkedRevoked.context": "This document is linked in your current map.",
  "sync.linkedRevoked.recover": "Recover",
  "sync.linkedRevoked.deferred": "Recovery deferred. Recover \"{name}\" from the notifications panel when ready.",
  "sync.linkedRevoked.deferredUnnamed": "Recovery deferred. Recover this linked document from the notifications panel when ready.",
  "sync.linkedRevoked.recovered": "\"{name}\" recovered to your vault. Links updated.",
  "sync.linkedRevoked.recoveredUnnamed": "\"the linked document\" recovered to your vault. Links updated.",
  "sync.linkedRevoked.noData": "Recovery of \"{name}\" failed: no data available.",
  "sync.linkedRevoked.noDataUnnamed": "Recovery of \"the linked document\" failed: no data available.",
  "sync.linkedRevoked.failed": "Recovery of \"{name}\" failed. Try again from the notifications panel.",
  "sync.linkedRevoked.failedUnnamed": "Recovery of \"the linked document\" failed. Try again from the notifications panel.",

  // interfaces/classic/ui/update-manager.js: update banner
  "sync.update.available": "A new version is available",
  "sync.update.required": "Update required. You can still work offline, but sync is paused until you refresh this page.",

  // storage/*: saving before a reload or close failed; the desktop app could not open its vault
  "sync.save.failedWeb": "Orbital could not save your changes. The page has stayed open. Check available browser storage and retry.",
  "sync.save.failedDesktopReload": "Orbital could not save your changes. The window has stayed open. Check disk space and vault permissions, then try again.",
  "sync.save.failedDesktopClose": "Orbital could not save your changes. The window has stayed open. Check disk space and vault permissions, then close it again.",
  "sync.vault.openFailed": "Orbital could not open this vault",
  // engine/sync/map-format-migration.js: card while a very large map moves to schema v2
  "sync.mapFormat.title": "Updating this map",
  "sync.mapFormat.intro": "Updating how this map is stored, so that edits made at the same time on several devices are all kept.",
  "sync.mapFormat.progress": "{count} nodes",
  "sync.mapFormat.failed": "The update did not finish. The map stays as it was.",
  // engine/sync/refused-changes.js, interfaces/classic/ui/modals.js: a viewer's changes the server will not store
  "sync.refused.title": "Changes not saved",
  "sync.refused.lead_one": "{count} change made on this device could not be saved: you can now only view this map.",
  "sync.refused.lead_other": "{count} changes made on this device could not be saved: you can now only view this map.",
  "sync.refused.leadUnknown": "Changes made on this device could not be saved: you can now only view this map.",
  "sync.refused.explainer": "“Save them as a copy” keeps the map as this device has it, as a new map of your own. “Discard them” shows the map as it is on the server.",
  "sync.refused.copy": "Save them as a copy",
  "sync.refused.discard": "Discard them",
  "sync.refused.copyName": "{title} (my changes)",
  "sync.refused.copyFailed": "The copy could not be made. Your changes stay on this device; you will be asked again when you open the map.",
};
